window.addEventListener('load', () => {
  // Select the navbar and logo elements
  const navbar = document.querySelector(".v_navbar");
  const logo = document.querySelector("#v_navbar__logo");



  if (navbar) {
    // Initialize previous scroll position, isScrolled and isScrollingDown flags
    let prevScrollPos = window.pageYOffset;
    let isScrolled = false;
    let isScrollingDown = false;
    const isNewsroomShow = navbar.dataset.newsroomShow === "true";

    // Select the toggle link and the dropdown menu
      const dropdownToggle = document.querySelector('.dropdown-toggle');
      const dropdownMenu   = document.querySelector('.dropdown-menu');

    // Add click event to toggle the menu
    dropdownToggle.addEventListener('click', function(event) {
      event.preventDefault();
      dropdownMenu.classList.toggle('show');
    });

    //  Close the menu when clicking outside
    document.addEventListener('click', function(event) {
      if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
        dropdownMenu.classList.remove('show'); // Hide the menu
      }
    });

    // Function to handle scroll events
    function handleScroll() {

      // Update isScrolled flag based on the scroll position
      isScrolled = window.scrollY > 30;
      // Toggle classes on navbar and logo elements based on isScrolled flag
      navbar?.classList.toggle("v_navbar__scrolled", isScrolled);
      if (isScrolled) dropdownMenu.classList.remove('show');
      if (!isNewsroomShow) {
        logo?.classList.toggle("v_navbar__logo_black", isScrolled);
      }
      // Get the current scroll position and update isScrollingDown flag
      const currentScrollPos = window.pageYOffset;
      isScrollingDown = prevScrollPos < currentScrollPos;
      // Toggle class on navbar element based on isScrollingDown flag
      navbar?.classList.toggle("v_navbar__out_of_the_frame", isScrollingDown);
      if (window.scrollY < 50) {
        navbar?.classList.remove("v_navbar__out_of_the_frame");
      }

      // Update the previous scroll position
      prevScrollPos = currentScrollPos;
    }

    // Initialize ticking flag
    let ticking = false;

    // Function to request a new animation frame
    function requestTick() {
      // If the tick is not already requested, request a new animation frame
      if (!ticking) {
        requestAnimationFrame(() => {
          // Call the handleScroll function
          handleScroll();
          // Reset the ticking flag
          ticking = false;
        });
        // Set the ticking flag to true
        ticking = true;
      }
    }

    // Add a scroll event listener to the window and call the requestTick function
    window.addEventListener("scroll", requestTick);
    handleScroll();

  } else {
    console.error("Nav element not found")
  }
});